import { render, staticRenderFns } from "./Diplom.vue?vue&type=template&id=746db02a&lang=pug&"
import script from "./Diplom.vue?vue&type=script&lang=ts&"
export * from "./Diplom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports